import React from 'react';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../../../i18n/TModules';
import { limitErrors } from '../../adapters/limits';
import StepPanel from '../../kit/StepPanel';
import { Divider, Form } from '../../kit/layout';
import { EnrolmentFields, LimitLine } from '../../kit/limitFields';
import { IWizardStepProps, WizardLimits } from '../../wizardModel';

const TL = `${TOrbit}.wizard.limits`;

/** 6778:20581, Step 5/5: three card limits, then enrolment. */
const StampLimitsStep: React.FC<IWizardStepProps> = ({ state, update, next, back }) => {
  const { t } = useMultiLanguageTranslation();
  const { limits } = state;
  const change = (patch: Partial<WizardLimits>) =>
    update(current => ({ ...current, limits: { ...current.limits, ...patch } }));

  return (
    <StepPanel
      step="limits"
      title={t(`${TOrbit}.wizard.setup.stamp`)}
      question={t(`${TL}.question`)}
      errors={limitErrors(state, t)}
      onNext={next}
      onBack={back}
    >
      <Form>
        <LimitLine
          on={limits.totalOn}
          onToggle={totalOn => change({ totalOn })}
          leadIn={t(`${TL}.stampCards`)}
          value={limits.total}
          onChange={total => change({ total })}
          hint={t(`${TL}.stampCardsHint`)}
        />
        <LimitLine
          on={limits.perUserOn}
          onToggle={perUserOn => change({ perUserOn })}
          leadIn={t(`${TL}.stampPerUser`)}
          value={limits.perUser}
          onChange={perUser => change({ perUser })}
          unit={t(`${TL}.stampPerUserUnit`)}
        />
        <LimitLine
          on={limits.userRateOn}
          onToggle={userRateOn => change({ userRateOn })}
          leadIn={t(`${TL}.stampPerPeriod`)}
          value={limits.userRate}
          onChange={userRate => change({ userRate })}
          unit={t(`${TL}.stampPerPeriodUnit`)}
          period={{
            value: limits.userRatePeriod,
            onChange: userRatePeriod => change({ userRatePeriod })
          }}
        />
        <Divider />
        <EnrolmentFields limits={limits} onChange={change} withTime={false} />
      </Form>
    </StepPanel>
  );
};

export default StampLimitsStep;
